import React from 'react';
import { Field } from 'redux-form';
import renderSelect from '../fields/renderSelect';
import UploadSection from '../common/upload';
import i18n from '../../translations/i18n';

let OfficialTranslation = props => {
	let lng = props.lng;
	return (
		<div>
		<div className="form-section">
		<div className="subtitle title title-border title-border text-left">
			<h6>{i18n.t('official.title', {lng})}</h6>
		</div>
		<div className="row">
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="countryOfOrigin"
					component={renderSelect}
					label={i18n.t('official.country_of_origin', {lng})}
					options={props.countries}
					placeholder={i18n.t('app.please_select', {lng})}
					tooltip={i18n.t('official.country_of_origin_tooltip', {lng})}
				/>
			</div>
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="processingCountry"
					component={renderSelect}
					label={i18n.t('official.processing_country', {lng})}
					options={props.countries}
					placeholder={i18n.t('app.please_select', {lng})}
					tooltip={i18n.t('official.processing_country_tooltip', {lng})}
				/>
			</div>
		</div>
		<div className="row">
			<div className="col-12 form-input">
				<Field
					name="requestOrigin"
					component={renderSelect}
					label={i18n.t('official.request_origin', {lng})}
					options={props.requestOrigin}
					placeholder={i18n.t('app.please_select', {lng})}
				/>
			</div>
		</div>
		<div className="row">
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="sourceLanguage"
					component={renderSelect}
					label={i18n.t('official.source_language', {lng})}
					options={props.fromLang}
					placeholder={i18n.t('app.please_select', {lng})}
				/>
			</div>
			<div className="col-12 col-sm-6 form-input">
				<Field
					name="targetLanguage"
					component={renderSelect}
					label={i18n.t('official.target_language', {lng})}
					options={props.toLang}
					placeholder={i18n.t('app.please_select', {lng})}
				/>
			</div>
		</div>
		</div>
		<div className="form-section">
			<UploadSection
				lng={props.lng}
				service="official"
				documents={props.documentTypes}
			/>
		</div>
		{props.showHelpText&&<div>
			<p className="small-text-bold orange">{i18n.t('official.upload_help_text', {lng})}</p>
		</div>}
	</div>
	)
}


export default OfficialTranslation


// WEBPACK FOOTER //
// ./src/components/translation/official.js